import { type FC, type PropsWithChildren } from 'react';

import { stopPropagation } from '@/packages/utils/event';

import styles from './PortalEventStoper.css';

export const PortalEventStoper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['wrapper']} onClick={stopPropagation}>
      {children}
    </div>
  );
};
